<span class="tag">Friss hírek</span>
<div class="news">
    <a [routerLink]="['/hir', latestNews[activeNewsIndex].slug]" [title]="latestNews[activeNewsIndex].title">{{latestNews[activeNewsIndex].title}}</a>
</div>
<span class="p-ml-auto"></span>
<span class="button button-prev" (click)="prev()"></span>
<span class="button button-next" (click)="next()"></span>